import {SpecialCategories} from './uploads';
import {dataFileUploadModuleFactory} from '../utils';

export default dataFileUploadModuleFactory(SpecialCategories.CLOUDCOMPUTING, {
   templateUrl: '/api/cloudcomputing/excel-template',
});
